import { Store, AnyAction } from "redux";
import * as StoreModule from "store";
import { SwishCallbackResponse } from "burde";

export const registerSignalR = async (
    store: Store<StoreModule.ApplicationState, AnyAction>,
    culture: string,
) => {
    if (typeof window === "undefined") {
        return;
    }

    // dynamically require in componentDidMount to exclude from server-side bundle
    const SignalR = require("@aspnet/signalr");
    // Only add Swish callback for Swedish culture.
    if (culture == "sv-SE") {
        const connection = new SignalR.HubConnectionBuilder()
            .withUrl("/callback")
            .build();

        if (!connection) {
            return;
        }

        // NOTE(Jesper): We might be able to remove this completely.
        try {
            await connection.start();
        } catch (e) {
            console.error(e);
        }
    }
};
